/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SensorConsumptionRecord from './SensorConsumptionRecord';

/**
* The SensorConsumptionResponse model module.
* @module model/SensorConsumptionResponse
* @version 2020-12-7
*/
export default class SensorConsumptionResponse {
    /**
    * Constructs a new <code>SensorConsumptionResponse</code>.
    * 消費量センサーデータ
    * @alias module:model/SensorConsumptionResponse
    * @class
    * @param tankId {Number} タンク番号
    * @param tankMaxVolume {Number} タンク上限
    * @param oilMaxVolume {Number} 最大容量
    * @param serialNo {String} シリアルNo
    * @param records {Array.<module:model/SensorConsumptionRecord>} センサーデータ
    */

    constructor(tankId, tankMaxVolume, oilMaxVolume, serialNo, records) {
        
        
        this['tankId'] = tankId;
        this['tankMaxVolume'] = tankMaxVolume;
        this['oilMaxVolume'] = oilMaxVolume;
        this['serialNo'] = serialNo;
        this['records'] = records;
        
    }

    /**
    * Constructs a <code>SensorConsumptionResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorConsumptionResponse} obj Optional instance to populate.
    * @return {module:model/SensorConsumptionResponse} The populated <code>SensorConsumptionResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorConsumptionResponse();
                        
            
            if (data.hasOwnProperty('tankId')) {
                obj['tankId'] = ApiClient.convertToType(data['tankId'], 'Number');
            }
            if (data.hasOwnProperty('tankMaxVolume')) {
                obj['tankMaxVolume'] = ApiClient.convertToType(data['tankMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('oilMaxVolume')) {
                obj['oilMaxVolume'] = ApiClient.convertToType(data['oilMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
            if (data.hasOwnProperty('records')) {
                obj['records'] = ApiClient.convertToType(data['records'], [SensorConsumptionRecord]);
            }
        }
        return obj;
    }

    /**
    * タンク番号
    * @member {Number} tankId
    */
    'tankId' = undefined;
    /**
    * タンク上限
    * @member {Number} tankMaxVolume
    */
    'tankMaxVolume' = undefined;
    /**
    * 最大容量
    * @member {Number} oilMaxVolume
    */
    'oilMaxVolume' = undefined;
    /**
    * シリアルNo
    * @member {String} serialNo
    */
    'serialNo' = undefined;
    /**
    * センサーデータ
    * @member {Array.<module:model/SensorConsumptionRecord>} records
    */
    'records' = undefined;




}
